import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cep-to-uxp"
    }}>{`CEP to UXP`}</h1>
    <p>{`Migrate from `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-CEP/CEP-Resources/blob/master/CEP_11.x/Documentation/CEP%2011.1%20HTML%20Extension%20Cookbook.md"
      }}>{`CEP panel`}</a>{` to UXP by following the `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-CEP/CEP-Resources/tree/master/UXP-Migration-Guide"
      }}>{`migration Guide`}</a>{`.`}</p>
    {/* 
     TODO This might be useful https://developer.adobe.com/photoshop/uxp/2022/guides/uxp_for_you/uxp_for_cep_devs/#goodbye-cep */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      